import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/jukeTreasureApi'

class Store {
  @observable list = []
  @observable total = 1
  @observable
  pagination = {
    current: 1,
    pageSize: 15,
    total: 1
  }

  @action
  getList = async page => {
    const { pagination } = this
    let params = {
      per_page: 15,
      page: page ? page : pagination.current,
      type: '1,2'
    }
    let {
      data: { list, total_count }
    } = await Api.charge_list(params)
    runInAction(() => {
      this.list = list
      this.pagination.total = +total_count
    })
  }

  @action
  setPage = page => {
    this.pagination.current = page.current
    this.getList(page.current)
  }
}
export default new Store()
